import typeHelper from './typeHelper'
import { IS_WIDESCREEN } from './constants'

export default typeHelper(IS_WIDESCREEN)
